import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard } from 'noddi-ui-web';
import { useUserGroupHasAddresses } from '../../hooks/useUserGroupHasAddresses';
import { ProfileAddressForm } from './ProfileAddressForm';

type Props = {
  userGroupId: number;
  /** ISO alpha-2 for manual create; defaults to NO when unknown. */
  countryCode?: string;
  /** Called after a new address is saved on the user group. */
  onSaved?: () => void;
};

/** Shown only when the user group has no saved address. */
export const MissingProfileAddressCard = ({ userGroupId, countryCode, onSaved }: Props) => {
  const { hasAddress, isLoading } = useUserGroupHasAddresses(userGroupId);

  if (isLoading || hasAddress) {
    return null;
  }

  return (
    <NoddiBasicCard className='flex flex-col gap-4'>
      <div className='flex flex-col gap-1'>
        <h2 className='text-lg font-semibold text-primary'>
          <Trans>Address</Trans>
        </h2>
        <span className='text-sm text-muted-foreground'>
          <Trans>We need an address on your profile for payment. It is saved to your account.</Trans>
        </span>
      </div>

      <ProfileAddressForm
        userGroupId={userGroupId}
        countryCode={countryCode}
        ctaLabel={t`Save address`}
        ctaClassName='w-full sm:w-fit'
        onSaved={() => onSaved?.()}
      />
    </NoddiBasicCard>
  );
};
